import type { SocialPlatform } from "@/types/social-engagement";
import { ShimmerBox, Stack } from "@biom3/react";
import Image from "next/image";
import { getPlatformName } from "./modalConfig";
import { getPlatformIcon } from "./modalConfig";

const ALL_PLATFORMS: SocialPlatform[] = ["x", "telegram"];

export const AnalyzingView = () => {
  return (
    <Stack
      direction="column"
      gap="base.spacing.x6"
      sx={{
        width: "100%",
        mt: "base.spacing.x8",
        px: "base.spacing.x6",
        alignItems: "flex-start",
      }}
    >
      {ALL_PLATFORMS.map((platform) => {
        return (
          <Stack
            key={platform}
            direction="row"
            alignItems="center"
            gap="base.spacing.x4"
            sx={{ width: "100%" }}
          >
            <Image
              src={getPlatformIcon(platform)}
              alt={`${getPlatformName(platform)} icon`}
              width={24}
              height={24}
              style={{ objectFit: "contain" }}
            />
            <ShimmerBox
              sx={{
                w: "100%",
                h: "20px",
              }}
            />
          </Stack>
        );
      })}
    </Stack>
  );
};
